import { render, staticRenderFns } from "./SalesNoteItem.vue?vue&type=template&id=156c914d&scoped=true&"
import script from "./SalesNoteItem.vue?vue&type=script&lang=js&"
export * from "./SalesNoteItem.vue?vue&type=script&lang=js&"
import style0 from "./SalesNoteItem.vue?vue&type=style&index=0&id=156c914d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c914d",
  null
  
)

export default component.exports